import styled from 'styled-components';


export const Container = styled.div`


background-color: white;

width: 100%;

height: 100%;


padding: 30px;




`;
export const Title = styled.h1`


font-size: 30px;
color:#545454;  


`;

export const SubTitle = styled.h5`


color:#9e9e9e;  
font-size: 20px;


`;



export const Controle = styled.div`


color:#9e9e9e;  
font-size: 20px;


display: flex;
justify-content: flex-start;
align-items: center;


`;


export const TdAction = styled.td`


display: flex;
justify-content: center;
align-items: center;


`;



export const PaginationSpot = styled.div`
       width:100%;
       
`;

